query getChainMigrationData($eth_address: String!) {
  getChainMigrationData(eth_address: $eth_address) {
    __typename
    migration_state
    oldBalance
    newBalance
    oldPositions
    newPositions
    oldStakeValue
    newStakeValue
  }
}
